<template>
  <div style="padding-bottom: 90px; overflow-y: hidden;" id="contenddash">
    <nav class="navbar navbar-dark " style="padding-right: 30px; padding-left: 30px; display: flex; justify-content: space-around;">

      <i style="font-size: 20px;" @click.prevent="mtdvoltames()" class="bi bi-chevron-left"></i>
      <h6>{{ mesatual }}</h6>
      <i style="font-size: 20px;" @click.prevent="mtdavancames()" class="bi bi-chevron-right"></i>
    </nav>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6" style="margin-top: 10px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-dash">
                <span class="tit-card-dash">Saldo agregado <small> (disponível atualmente)</small></span>
              </div>
              <div class="card-body" style="padding-bottom: 10px;">
                <div class="row">
                  <div class="col-md-12" style="display: flex; justify-content: center;">
                    <span v-if="parseFloat(vsaldoagregado) > 0" style="font-size: 25px; color: darkcyan;">{{
                      mtdformatavalordecimal(vsaldoagregado, 'R$') }}</span>
                    <span v-else style="font-size: 25px; color: brown;">{{ mtdformatavalordecimal(vsaldoagregado, 'R$')
                      }}</span>
                  </div>
                </div>
                <div class="row">
                  <div v-show="mostrasaldos" class="row">
                    <!-- aqui mostrar uma listagem de cada banco com seu icone e seu saldo -->
                    <div v-for="banco in listabancos" :key="banco.id" class="col-md-12"
                      style="display: flex; align-items: center; justify-content: space-between; padding: 5px 10px; border-bottom: 1px solid #ddd;">
                      <div style="display: flex; align-items: center;">
                        <i :class="banco.icone" style="font-size: 20px; margin-right: 10px;"></i>
                        <span>{{ banco.descricao }}</span>
                      </div>
                      <span :style="{ color: banco.saldo > 0 ? 'darkcyan' : 'brown', fontSize: '18px' }">
                        {{ mtdformatavalordecimal(banco.saldo, 'R$') }}
                      </span>
                    </div>
                  </div>
                  <button @click.prevent="mtdmostrarescondersaldos()"
                    :class="!mostrasaldos ? 'btn primary' : 'btn info'" type="button">
                    <span>Saldos</span>
                    <span><i
                        :class="!mostrasaldos ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6" style="margin-top: 10px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-dash">
                <span v-if="!futuro" class="tit-card-dash">Resultados do mês <small> (receitas - despesas)</small>
                </span>
                <span v-else class="tit-card-dash">Previsão do mês <small> (receitas - despesas)</small> </span>
              </div>
              <div class="card-body" style="padding-bottom: 10px;">

                <div class="row justify-content-center mb-2">
                  <div class="col-auto">
                    <span class="text-success" style="font-size: 15px;">
                      {{ mtdformatavalordecimal(totalReceitas, 'R$') }}
                    </span>
                  </div>
                  <div class="col-auto">
                    <span class="text-danger" style="font-size: 15px;">
                      {{ mtdformatavalordecimal(totalDespesas, 'R$') }}
                    </span>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-auto">
                    <span v-if="parseFloat(resultadoLiquido) > 0" style="font-size: 25px; color: darkcyan;">{{
                      mtdformatavalordecimal(resultadoLiquido, 'R$') }}</span>
                    <span v-else style="font-size: 25px; color: brown;">{{ mtdformatavalordecimal(resultadoLiquido,
                      'R$')
                      }}</span>

                  </div>
                </div>

                <div class="row">
                  <div v-show="mostraresultado" style="max-height: 200px; overflow: auto;" class="container-fluid">
 
                    <table class="table table-sm">
                      <thead>
                        <tr>

                        </tr>
                      </thead>
                      <tbody>
                        <!-- eslint-disable  -->
                        <template v-for="(resultado) in listaresultados" >
                            <tr style="padding-top: 8px;">
                              <td style="font-size: x-small;"><i class="bi bi-pen" v-show="parseInt(resultado.transferencia) === 0" style="margin-right: 5px; font-size: 15px;" @click.prevent="mtdalteralancto(resultado)" ></i> {{ resultado.nome }}</td>
                              <td class="text-center" style="font-size: 10px;">
                                <i class="bi bi-calendar-week-fill" style="margin-right: 5px;"></i>
                                {{ resultado.dtlancamento.slice(0, -9) }}
                              </td>
                              <td v-show="parseInt(resultado.transferencia) === 0" class="text-right" style="font-size: x-small; text-align: right;"
                                :style="{ color: resultado.tipo > 0 ? 'darkcyan' : 'brown' }">
                                {{ mtdformatavalordecimal(resultado.valor, 'R$') }}
                              </td>
                              <td v-show="parseInt(resultado.transferencia) === 1" class="text-right" style="font-size: x-small; text-align: right; color: cornflowerblue"
                                 >
                                {{ mtdformatavalordecimal(resultado.valor, 'R$') }}
                              </td>
                          </tr>

                          <tr v-if="resultado.desclancto !== ''" >
                             <td colspan="3" style=" font-size: x-small; padding-top: 0; height: 1px;" >{{resultado.desclancto}}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>


                  </div>
                  <button @click.prevent="mtdmostraresconderresultados()"
                    :class="!mostraresultado ? 'btn primary' : 'btn info'" type="button">
                    <span>Detalhes</span>
                    <span><i
                        :class="!mostraresultado ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="col-12 col-sm-12 col-md-6 col-lg-6" style="margin-top: 10px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-dash">
                <span class="tit-card-dash">Receitas por categorias</span>
              </div>
              <div class="card-body" style="padding-bottom: 10px;">
                <div class="row">
                  <div class="col-md-12" style="display: flex; justify-content: center;">
                    <graficopie :titulo="''" :subtitulo="''" :tema="'westeros'" :rotulo="'Det:'"
                      :legendas="legendareceitascateg" :dados="dadosreceitascateg" :visualizarlegenda="false"
                      :posicaolabel="'outside'"></graficopie>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6" style="margin-top: 10px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-dash">
                <span class="tit-card-dash">Despesas por categorias</span>
              </div>
              <div class="card-body" style="padding-bottom: 10px;">
                <div class="row">
                  <div class="col-md-12" style="display: flex; justify-content: center;">
                    <graficopie :titulo="''" :subtitulo="''" :tema="'essos'" :rotulo="'Det:'"
                      :legendas="legendadespesacateg" :dados="dadosdespesascateg" :visualizarlegenda="false"
                      :posicaolabel="'outside'"></graficopie>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" style="margin-top: 10px;">
        <div class="row">
          <button @click.prevent="mtdmostrargraficos()" :class="!mostrafiltro ? 'btn primary' : 'btn info'"
            type="button">
            <span>Mais gráficos</span>
            <span><i :class="!mostrafiltro ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
          </button>
        </div>
      </div>

      <div class="col-12" style="margin-top: 10px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-dash">
                <span class="tit-card-dash">Metas e objetivos</span>
              </div>
              <div class="card-body" style="padding-bottom: 10px;">
                <template v-if="lstmetas.length > 0">
                  <div v-for="(meta, indmeta) in lstmetas" :key="indmeta" class="row">
                    <div class="card">
                      <div class="card-header card-dash">

                        <span class="tit-card-dash"><i style="font-size: 26px;" :class="'bi ' + meta.adesivo"></i> {{
                          meta.descricao }}</span>
                      </div>
                      <div class="card-body" style="padding-bottom: 10px;">
                        <div class="row">
                          <div class="progress">
                            <div class="progress-bar" role="progressbar"
                              :style="'width: ' + parseInt(meta.percentual) + '%;'"
                              :aria-valuenow="parseInt(meta.percentual)" aria-valuemin="0" aria-valuemax="100">
                              {{ parseInt(meta.percentual) }}% da meta</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div style="display: flex; justify-content: center;">
                    <span style="font-size: 12px;">Sem metas no momento</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

     <modal-lancamento
      :show="mostrarModal"
      :key="modalKey"
      :lancamento="lanctoselecto"
      @fechar="mtdfechamodal()"
    />

  </div>
</template>

<script>
/* eslint-disable */
import util from './util.js';
import GraficoPie from './graficos/graficodoughnut.vue';
import ModalLancamento from './components/detalheslancto.vue';
export default {
  name: 'dash',
  data: function () {
    const hoje = new Date();
    return {
      mesatual: this.getNomeMes(hoje),  // Formata o mês atual para exibir no template
      peridosql: this.getPeriodoSQL(hoje), // Formata o período SQL inicial
      dataAtual: hoje, // Guarda a data atual para manipulação

      legendadespesacateg: [],
      dadosdespesascateg: [],
      dadosreceitascateg: [],
      legendareceitascateg: [],
      lstmetas: [],
      vsaldoagregado: 0,
      mostrasaldos: false,
      mostraresultado: false,
      listabancos: [

      ],
      listaresultados: [

      ],

      //modal
      lanctoselecto: [],
      modalKey     : '', 
      mostrarModal : false,


      //previsao
      totalReceitas: 0,
      totalDespesas: 0,
      resultadoLiquido: 0,
      futuro: false


    };
  },
  components: {
    'graficopie': GraficoPie,
    ModalLancamento,
  },
  methods: {
    mtdfechamodal(){
      this.mostrarModal = false;
      this.mtdexecutadash();
    },
    mtdalteralancto(lancamento){
        this.modalKey      = util.gerarStringAleatoria();
        this.lanctoselecto = lancamento;
        this.mostrarModal  = true; 
    },
    mtdmostrargraficos() {
      $('#menu').hide();
      $('#dash').hide();
      $('#relatorios').show();
    },
    mtdmostrarescondersaldos() {
      if (this.mostrasaldos) {
        this.mostrasaldos = false
      } else {
        this.mostrasaldos = true
      }
    },
    mtdmostraresconderresultados() {
      if (this.mostraresultado) {
        this.mostraresultado = false
      } else {
        this.mostraresultado = true
      }
    },
    mtdformatavalordecimal(valor, digitos) {
      return util.formatarvalor(valor, digitos);
    },
    mtdavancames() {
      this.dataAtual.setMonth(this.dataAtual.getMonth() + 1); // Incrementa o mês
      this.atualizaMesPeriodo();
    },
    // Retrocede para o mês anterior
    mtdvoltames() {
      this.dataAtual.setMonth(this.dataAtual.getMonth() - 1); // Decrementa o mês
      this.atualizaMesPeriodo();
    },
    // Atualiza o mês e o período SQL
    atualizaMesPeriodo() {
      this.mesatual = this.getNomeMes(this.dataAtual);
      this.peridosql = this.getPeriodoSQL(this.dataAtual);



      this.mtdexecutadash();
    },
    // Retorna o nome do mês com o ano
    getNomeMes(data) {
      const nomeMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
      return `${nomeMeses[data.getMonth()]} ${data.getFullYear()}`;
    },
    // Retorna o período SQL de acordo com o mês e ano da data
    getPeriodoSQL(data) {

      //verifica se a data que selecionei está no futuro
      let new_hj = new Date();
      let legdata = data;

      if (legdata > new_hj) {
        this.futuro = true
      } else {
        this.futuro = false
      }


      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0'); // Formata o mês com dois dígitos
      const ultimoDia = new Date(ano, data.getMonth() + 1, 0).getDate(); // Último dia do mês
      return `'${ano}-${mes}-01 00:00:00' and '${ano}-${mes}-${ultimoDia} 23:59:59'`;
    },
    mtdexecutadash() {
      var vself = this;

      let parametros = [
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
        { parametro: 'op', valor: 'executadash' },
        { parametro: 'periodo', valor: vself.peridosql },
        { parametro: 'previsao', valor: vself.futuro ? 1 : 0 }
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/dashboard.php');
      retorno.then(function (response) {
        vself.dadosdespesascateg = response.data.despesascateg;
        vself.legendadespesacateg = util.gerardadoslegendagrafico(response.data.despesascateg);
        vself.dadosreceitascateg = response.data.receitascateg;
        vself.legendareceitascateg = util.gerardadoslegendagrafico(response.data.receitascateg);
        vself.lstmetas = response.data.metas;
        vself.vsaldoagregado = response.data.saldoagregado;
        vself.listabancos = response.data.contas;


        vself.listaresultados = response.data.lstprevresumo;
        vself.totalReceitas = response.data.totalentradas;
        vself.totalDespesas = response.data.totalsaidas;

        vself.resultadoLiquido = parseFloat(vself.totalReceitas) - parseFloat(vself.totalDespesas);

      }).catch(function (response) {

      });

    },
  },
  mounted() {
    let vself = this
    vself.mtdexecutadash();


    document.getElementById("btdash").addEventListener("click", function () {
      vself.mtdexecutadash();
    });

  }
}
</script>

<style></style>